import React from "react";
import { Col, Row } from "react-bootstrap";
import Cookies from "js-cookie";
import BackHistory from "@/containers/BackHistory/BackHistory";
import SntBrowserTabTitle from "@cleanup/components/SntBrowserTabTitle";
import SntHideLongText from "@/components/ReactBootstrap/SntHideLongText";

interface ActionHeaderProps {
  title: string;
  tabTitle?: string;
  renderHeaderIcon?: () => React.ReactNode;
  toolbar?: React.ReactNode;
  /** Back arrow is opt-in: only detail/drill-in pages enable it (STIC-15588). */
  isShowBackHistory?: boolean;
  /**
   * Canonical parent route for the back arrow when the page is opened
   * without in-app history (direct URL / bookmark). See BackHistory.
   */
  backTo?: string;
}

const ActionHeader: React.FC<ActionHeaderProps> = ({
  title,
  tabTitle,
  renderHeaderIcon,
  toolbar,
  isShowBackHistory = false,
  backTo,
}) => {
  const sensolusFullScreen = Cookies.get("sensolus-full-screen");

  if (sensolusFullScreen) return <></>;

  return (
    <Row>
      <Col xs="12">
        <SntBrowserTabTitle title={tabTitle || title} />

        <div className="d-flex justify-content-between heading">
          <div className="d-flex align-items-center w-50">
            {isShowBackHistory && <BackHistory backTo={backTo} />}
            <h1 className="page-header">
              <SntHideLongText>{title}</SntHideLongText>
            </h1>
            {renderHeaderIcon && renderHeaderIcon()}
          </div>
          <div className="d-flex justify-content-end align-items-center w-50">
            {toolbar && toolbar}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ActionHeader;
